import { render } from "./GenreView.vue?vue&type=template&id=04f8e2f8"
import script from "./GenreView.vue?vue&type=script&lang=js"
export * from "./GenreView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__